module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Regular.cfcd6e0e.woff2";